<div class="news-wrap">
    <div class="details-area ui-g">
        <div class="ui-g-8 ui-lg-8 ui-md-8 ui-sm-12">
            <div class="main-wrap">
                <div class="news-head-section" [style.backgroundImage]="'url(' + global?.basePathImage  + SingleNews?.banner + ')'">
                    <!-- <img class="img-responsive" [src]="global?.basePathImage + SingleNews?.banner" alt=""> -->
                </div>
                <h2 class="main-heading">
                    {{SingleNews?.name}}
                </h2>
                
                <p class="event-time" [id]="SingleNews._id"></p>

                <p class="main-para">
                 {{SingleNews?.description}}
                </p>
            </div>
        </div>
        <div class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12">
            <div *ngFor="let data of news" class="side-wrap">
                <div class="news-card">
                    <div class="image">
                        <div class="news-image" [style.backgroundImage]="'url(' + global?.basePathImage  + data?.banner + ')'"></div>
                    </div>
                    <div class="news-image-line"></div>
                    <h2 class="news-heading">
                        {{ data.name }}
                    </h2>

                   

                    <p class="news-content">
                        {{ data.description }}
                    </p>
                    <a (click)="newsDetails(data._id)" class="read-more">Read More</a>
                </div>
            </div>
        </div>
    </div>
</div>